import { graphql } from '../graphql/generated';

export const ORDER_LABEL_BY_UUID_QUERY = graphql(`
  query OrderLabelByUuid($id: ID!) {
    orderLabel(id: $id) {
      id
      name
      color
      order {
        id
        number
        request {
          id
          patientData {
            title
            firstName
            lastName
          }
          doctor {
            id
            name
          }
        }
        orderLabels {
          id
          name
          number
          features
          text
          text2
          color
          location
          specialPrinterRequired
        }
      }
    }
  }
`);

export const MARK_LABEL_PRINTED_MUTATION = graphql(`
  mutation MarkLabelPrinted($id: ID!) {
    markOrderLabelPrinted(orderLabelId: $id) {
      id
    }
  }
`);
